import { ReactNode } from 'react';
import { cn } from '@sib/ui';
import { WifiError } from '@sib/ui/icons';

export interface NoStorageConnectionProps {
  title: string;
  description: ReactNode;
  className?: string;
}

export const NoStorageConnection = ({
  title,
  description,
  className,
}: NoStorageConnectionProps) => (
  <div
    className={cn(
      'flex h-full w-full flex-col items-center justify-center',
      className
    )}
  >
    <div className="border-border-soft flex h-full w-full flex-col items-center justify-center rounded-lg border px-8 py-10">
      <div className="relative mb-8 shrink-0">
        <div className="bg-soft-blue flex size-36 items-center justify-center rounded-full border-8 border-white p-8 drop-shadow-md">
          <WifiError className="text-primary size-16" aria-hidden="true" />
        </div>
      </div>
      <div className="flex max-w-lg flex-col items-center gap-4">
        <p
          role="heading"
          aria-level={2}
          className="text-primary m-0 text-center font-sans text-[28px] leading-[33.6px] font-medium tracking-[-0.005em]"
        >
          {title}
        </p>
        <div
          className={
            'text-muted-foreground text-center font-sans text-sm leading-4.5 font-medium tracking-normal [&_p]:m-0 [&_p]:text-sm [&_p]:leading-4.5 [&_p]:font-medium'
          }
        >
          {description}
        </div>
      </div>
    </div>
  </div>
);
